/* ============================================================
   THE HAPPINESS STORY — Full-Site behavior (dev-handoff base)
   ------------------------------------------------------------
   1. (retired) center-focus scroll  → assets/ths3-choreo.js
   2. (retired) .rv reveal-on-entry  → assets/ths3-choreo.js
   3. .sec-arrow buttons scroll to the next section.
   4. Filter chips (data-filter / data-cat).
   5. Simulated cart counter (page-session only — replace with
      Shopify cart in production).
   6. Form success states (no network; developers wire real
      endpoints later).
   7. Hero banner slideshow ([data-slideshow]) — crossfade carousel.
   8. (moved) headline word reveal → assets/ths3-choreo.js
   9. Count-up stat numbers ([data-countup]).
  10. Seamless logo/keepsake marquee ([data-marquee]).
  11. How-it-works step sequence ([data-steps]).
   All features degrade gracefully: no JS = fully readable page.
   ============================================================ */
(function () {
  'use strict';
  /* theme patch: in the Shopify theme editor, sections re-render without a
     page load, so JS-revealed elements would stay hidden (blank sections).
     Treat design mode as reduced motion AND flag it for CSS neutralization. */
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) document.documentElement.classList.add('ths3-editor');
  var reduced = designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 + 2. REMOVED 2026-08-06 — superseded by ths3-choreo.js
     1. "Center-focus scroll" scaled and dimmed EVERY .scene on
        every scroll frame based on its distance from the viewport
        centre. Two problems: it wrote an inline transform on every
        section (making each one a containing block, and putting a
        rAF style-write on the scroll path for the whole page), and
        it moved sections as rigid slabs — the opposite of the
        parts of a section relating to each other. The scroll-linked
        motion that replaced it drifts a section's COPY and its
        PHOTOGRAPHY against each other by a few pixels instead.

     2. The .rv reveal observer staggered by
        `sec.querySelectorAll('.rv:not(.in)').indexOf(el)`, a list
        that shrinks as elements reveal — so the delay an element
        got depended on how many of its siblings had already fired,
        and the "stagger" was different on every scroll speed. It
        also ran on a threshold of its own, unrelated to the section
        wipe and the word reveal, which is why nothing on the page
        appeared to be aware of anything else.

     Both are now one director with one trigger per section:
     assets/ths3-choreo.js.
  ────────────────────────────────────────────────────────────── */

  /* ── 3. Section down-arrows ─────────────────────────────── */
  document.querySelectorAll('.sec-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sec = btn.closest('section');
      var next = sec && sec.nextElementSibling;
      while (next && next.tagName !== 'SECTION' && next.tagName !== 'FOOTER') next = next.nextElementSibling;
      if (next) {
        var top = next.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
      }
    });
  });

  /* ── 4. Filter chips ────────────────────────────────────── */
  document.querySelectorAll('[data-filterbar]').forEach(function (bar) {
    var scope = bar.getAttribute('data-filterbar');            /* selector for the grid */
    var grid = document.querySelector(scope);
    if (!grid) return;
    /* optional companions in the same section: empty-state message + live count */
    var sec = bar.closest('section') || document;
    var empty = sec.querySelector('[data-filter-empty]');
    var countEl = sec.querySelector('[data-filter-count]');
    bar.addEventListener('click', function (ev) {
      var chip = ev.target.closest('.chip'); if (!chip || !bar.contains(chip)) return;
      bar.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('on'); });
      chip.classList.add('on');
      var f = (chip.getAttribute('data-filter') || '').toLowerCase();
      var shown = 0;
      grid.querySelectorAll('[data-cat]').forEach(function (item) {
        /* theme patch: substring match so chip "diwali" hits taxonomy tags like "festival:diwali" */
        var cats = (item.getAttribute('data-cat') || '').toLowerCase();
        var show = f === 'all' || cats.indexOf(f) !== -1;
        item.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
      if (countEl) {
        if (!countEl.dataset.orig) countEl.dataset.orig = countEl.textContent;
        if (f === 'all') {
          countEl.textContent = countEl.dataset.orig;   /* server total (covers all pages) */
        } else {
          var noun = shown === 1 ? (countEl.getAttribute('data-one') || 'match')
                                 : (countEl.getAttribute('data-many') || 'matches');
          countEl.textContent = shown + ' ' + noun;
        }
      }
    });
  });

  /* ── 5 + 6. REMOVED 2026-08-04 — prototype code, never shipped-safe
     These were two leftovers from the design prototype:

     5. "Simulated cart": intercepted [data-atc] clicks, called
        preventDefault(), incremented a LOCAL counter, painted that
        made-up number into .hdr-cart__n and showed the customer
        "✓ Added" — while adding precisely nothing to the real cart.
     6. "Demo form success": intercepted form[data-demo], called
        preventDefault() and printed "Sent — We Reply Within 24
        Hours" without ever submitting. On a B2B enquiry form that
        silently swallows leads.

     Verified with real DOM counts (not grep — see .claude-errors.json
     2026-08-03) across home/collection/PDP/cart/corporate/contact:
     0 live [data-atc] and 0 live form[data-demo], so neither was
     firing. They are deleted rather than left dormant because both
     activate the instant anyone adds that attribute to a section,
     and both fail by LYING to the customer.

     Real add-to-cart feedback now lives in ths3-life.js.
  ────────────────────────────────────────────────────────────── */

  /* ── PDP helpers (no-op on other pages) ─────────────────── */
  /* character counter for personalisation message */
  document.querySelectorAll('[data-count]').forEach(function (ta) {
    var out = document.querySelector(ta.getAttribute('data-count'));
    if (!out) return;
    var max = parseInt(ta.getAttribute('maxlength') || '150', 10);
    /* clear any stray value an app/URL-param may have injected (e.g. "NaN") so
       the field starts empty and the placeholder sample shows */
    if (ta.hasAttribute('data-clear-nan')) {
      var v = (ta.value || '').trim();
      if (v === '' || v.toLowerCase() === 'nan' || v === 'undefined' || v === 'null') { ta.value = ''; }
    }
    var render = function () { out.textContent = (max - ta.value.length) + ' characters left'; };
    ta.addEventListener('input', render);
    render();
  });
  /* qty stepper */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (ev) {
      var b = ev.target.closest('button'); if (!b) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + (b.getAttribute('data-step') === '+' ? 1 : -1));
    });
  });

  /* ══════════════════════════════════════════════════════════
     MOTION SYSTEM  (see README §“Motion & Animation”)
     Four opt-in engines. Each is a no-op when its hook is absent
     and each degrades to readable static content under
     prefers-reduced-motion or with JS disabled.
     ══════════════════════════════════════════════════════════ */

  /* ── 7. Hero banner slideshow ([data-slideshow]) ─────────── */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length < 2) return;
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var dotsWrap = root.querySelector('.hero-dots');
    var cur = Math.max(0, slides.findIndex ? slides.findIndex(function (s) { return s.classList.contains('is-active'); }) : 0);
    if (cur < 0) cur = 0;
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.className = 'hero-dot' + (i === cur ? ' on' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show slide ' + (i + 1));
        b.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }
    var timer = null;
    function go(n, manual) {
      n = (n + slides.length) % slides.length;
      if (n === cur) return;
      slides[cur].classList.remove('is-active');
      slides[cur].setAttribute('aria-hidden', 'true');
      slides[n].classList.add('is-active');
      slides[n].removeAttribute('aria-hidden');
      dots.forEach(function (d, i) { d.classList.toggle('on', i === n); });
      cur = n;
      if (manual) restart();
    }
    function play() { if (reduced) return; stop(); timer = setInterval(function () { go(cur + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); play(); }
    var prev = root.querySelector('.hero-nav--prev');
    var next = root.querySelector('.hero-nav--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
    if (next) next.addEventListener('click', function () { go(cur + 1, true); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true);
      x0 = null;
    });
    slides.forEach(function (s, i) { if (i !== cur) s.setAttribute('aria-hidden', 'true'); });
    play();
  });

  /* ── 8. Headline word reveal — MOVED 2026-08-06 ───────────
     The word split and its trigger now live in ths3-choreo.js, so
     a headline rises on its SECTION's beat (after that section's
     eyebrow, before its copy) instead of on a threshold of its own.
     Same .rw / .rw__i markup, same CSS. Splitting it here as well
     would double-wrap every word. */

  /* ── 9. Count-up numbers ([data-countup]) ────────────────── */
  var countEls = Array.prototype.slice.call(document.querySelectorAll('[data-countup]'));
  function fmt(v, dec) {
    var s = v.toFixed(dec).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return s.join('.');
  }
  function runCount(el) {
    var to = parseFloat(el.getAttribute('data-to') || '0');
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var pre = el.getAttribute('data-prefix') || '';
    var suf = el.getAttribute('data-suffix') || '';
    var dur = parseInt(el.getAttribute('data-dur') || '1600', 10);
    var t0 = null;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + fmt(to * eased, dec) + suf;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = pre + fmt(to, dec) + suf;
    }
    requestAnimationFrame(frame);
  }
  if (countEls.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      /* leave the authored final value in place */
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          runCount(e.target);
          cio.unobserve(e.target);
        });
      }, { threshold: 0.5 });
      countEls.forEach(function (el) { cio.observe(el); });
    }
  }

  /* ── 10. Marquee ([data-marquee]) ────────────────────────── */
  if (!reduced) {
    document.querySelectorAll('[data-marquee]').forEach(function (m) {
      var track = m.querySelector('.logo-marquee__track');
      if (!track) return;
      /* Clone the authored set enough times to fill the strip, then
         mirror that into a seamless loop.

         Duplicating ONCE (the old behaviour) is only seamless when one
         copy of the logos is already as wide as the visible strip. With
         four short text chips (~860px) on a 1824px desktop .wrap, half
         the track is 860px but the strip is 1824px — so the -50% travel
         ran out with ~1000px of bare band trailing behind the last logo.
         It read as the logos disappearing, and halving the speed doubled
         how long that emptiness sat on screen.

         So: repeat the set `half` times until it covers the strip, then
         lay down a second identical `half`. Travelling exactly one half
         lands copy N+1 precisely where copy N started — seamless, and
         there is always a full strip of logos in frame.

         Two older fixes preserved:
         1. aria-hidden goes on the CLONES only. It used to be applied to
            every child, originals included, so the entire client list was
            invisible to screen readers under a "Trusted by 500+ teams"
            heading.
         2. Clone nodes rather than re-assigning innerHTML, which re-parses
            the markup, discards already-decoded <img> elements and makes
            the browser fetch every logo a second time. */
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;
      var lastWidth = -1;

      function build() {
        /* back to the authored set, then re-clone for the current width */
        while (track.children.length > originals.length) {
          track.removeChild(track.lastChild);
        }
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
        var setW = 0;
        for (var i = 0; i < originals.length; i++) {
          setW += originals[i].getBoundingClientRect().width;
        }
        /* one gap per item: the internal ones plus the gap that joins
           this set to the next, which is what makes setW a clean period */
        setW += gap * originals.length;
        if (setW <= 0) return;

        var half = Math.max(1, Math.ceil(m.clientWidth / setW));
        var frag = document.createDocumentFragment();
        for (var c = 1; c < half * 2; c++) {
          for (var j = 0; j < originals.length; j++) {
            var dupe = originals[j].cloneNode(true);
            dupe.setAttribute('aria-hidden', 'true');
            frag.appendChild(dupe);
          }
        }
        track.appendChild(frag);

        /* Travel an exact pixel period, not -50%. A percentage of the
           whole track is off by half a gap every lap (the track has one
           fewer gap than it has items), which shows up as a small jump.

           Duration scales with `half` for a reason: --marq-dur is the time
           for ONE set of logos to pass, so the on-screen speed stays what
           the Theme Editor asked for no matter how many copies it took to
           fill this particular screen. Without this, a wide monitor that
           needs 3 copies would scroll 3x faster than a laptop. */
        var perSet = parseFloat(cs.getPropertyValue('--marq-dur')) || 48;
        track.style.setProperty('--marq-shift', (half * setW) + 'px');
        track.style.animationDuration = (perSet * half) + 's';
        lastWidth = m.clientWidth;
      }

      build();
      /* lazy logo images have no width until they land */
      window.addEventListener('load', function () {
        if (m.clientWidth) build();
      });
      var t;
      window.addEventListener('resize', function () {
        if (m.clientWidth === lastWidth) return;   /* mobile URL-bar noise */
        clearTimeout(t);
        t = setTimeout(build, 200);
      });
    });
  }

  /* ── 11. How-it-works step sequence ([data-steps]) ───────── */
  document.querySelectorAll('[data-steps]').forEach(function (container) {
    var steps = Array.prototype.slice.call(container.querySelectorAll('.step'));
    if (!steps.length) return;
    function revealAll() { steps.forEach(function (s) { s.classList.add('step-in'); }); }
    if (reduced || !('IntersectionObserver' in window)) { revealAll(); return; }
    var run = function () {
      steps.forEach(function (s, i) { setTimeout(function () { s.classList.add('step-in'); }, i * 260); });
    };
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(); sio.disconnect(); } });
    }, { threshold: 0.3 });
    sio.observe(container);
    setTimeout(revealAll, 3200);   /* safety */
  });

  /* ── 12. Looping card carousel ([data-carousel]) ──────────
     Track = [data-carousel-track] (horizontal scroll-snap; the mobile
     data-mrow rules already make it swipeable under 750px). Arrows page
     by one card; autoplay (data-interval ms, off when data-autoplay is
     "false") advances and loops back to the start. Pauses on hover /
     focus / touch / hidden tab. Reduced motion & editor: no autoplay,
     arrows still work. */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track || track.children.length < 2) return;
    function step() {
      var kids = track.children;
      return kids.length > 1 ? Math.max(kids[1].offsetLeft - kids[0].offsetLeft, 40) : track.clientWidth;
    }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 4; }
    function go(dir) {
      var behavior = reduced ? 'auto' : 'smooth';
      if (dir > 0 && atEnd()) { track.scrollTo({ left: 0, behavior: behavior }); return; }
      track.scrollBy({ left: step() * dir, behavior: behavior });
    }
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (reduced || root.getAttribute('data-autoplay') === 'false') return;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var timer = null;
    function play() { if (!timer) timer = setInterval(function () { go(1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    track.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    play();
  });

  /* ── 13. Reading spotlight — RETIRED 2026-07-18 ───────────
     The touch-device spotlight (child nearest viewport centre got
     .spotlit, siblings dimmed via .spoton CSS) always tied in favour
     of the LEFT item in 2-col grids and swipe rows, leaving the right
     item permanently dimmed ("blurred" — user-reported). Removed on
     touch; desktop keeps the pure-CSS hover spotlight (ths3.css §16). */

  /* ── 14. Accordion glide ([data-acc]) ─────────────────────
     PDP spec sheet + FAQ groups: smooth height+fade open/close via
     the Web Animations API, one row open per group. Falls back to
     native <details> under reduced motion, in the theme editor, or
     without WAAPI — content is always reachable. */
  var accGroups = Array.prototype.slice.call(document.querySelectorAll('[data-acc]'));
  if (accGroups.length && !reduced && 'animate' in Element.prototype) {
    accGroups.forEach(function (group) {
      var rows = Array.prototype.slice.call(group.querySelectorAll('details'));
      function glide(d, opening) {
        var body = d.querySelector('.ans');
        if (!body || d.hasAttribute('data-acc-anim')) { d.open = opening; return; }
        d.setAttribute('data-acc-anim', '');
        if (opening) d.setAttribute('open', '');
        var cs = getComputedStyle(body);
        var full = { height: body.scrollHeight + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 };
        var zero = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
        body.style.overflow = 'hidden';
        var anim = body.animate(opening ? [zero, full] : [full, zero], {
          duration: opening ? 340 : 240,
          easing: 'cubic-bezier(.2,.7,.25,1)'
        });
        anim.onfinish = anim.oncancel = function () {
          body.style.overflow = '';
          if (!opening) d.removeAttribute('open');
          d.removeAttribute('data-acc-anim');
        };
      }
      rows.forEach(function (d) {
        var sum = d.querySelector('summary');
        if (!sum) return;
        sum.addEventListener('click', function (ev) {
          ev.preventDefault();
          if (d.hasAttribute('data-acc-anim')) return;
          if (d.open) { glide(d, false); return; }
          rows.forEach(function (o) { if (o !== d && o.open) glide(o, false); });
          glide(d, true);
        });
      });
    });
  }

  /* ── 15. Add-to-Cart pending feedback ─────────────────────
     Every add-to-cart on this theme is a native form submit (the PDP
     form must stay non-AJAX so the personalisation photo upload
     works), so there is a full page load between the tap and the
     cart. With no feedback the button looks inert on a slow phone
     connection and gets tapped again — which adds the item twice.
     Mark the pressed button busy; CSS dims it and blocks further
     taps. Restore on bfcache/back, where the old DOM is reused. */
  (function () {
    function label(btn, text) {
      /* keep any icon children intact — only swap a leading text node */
      var node = null;
      for (var i = 0; i < btn.childNodes.length; i++) {
        if (btn.childNodes[i].nodeType === 3 && btn.childNodes[i].nodeValue.trim()) { node = btn.childNodes[i]; break; }
      }
      if (!node) return;
      if (text === null) {
        if (btn.hasAttribute('data-idle-label')) { node.nodeValue = btn.getAttribute('data-idle-label'); btn.removeAttribute('data-idle-label'); }
      } else {
        btn.setAttribute('data-idle-label', node.nodeValue);
        node.nodeValue = text;
      }
    }
    function idle(btn) { label(btn, null); btn.removeAttribute('aria-busy'); }

    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var btn = ev.submitter;
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      /* card buttons are handled by ths3-life.js, which adds over the
         cart API and owns their pending state end to end */
      if (!btn.matches('.m-atc__btn, [data-atc-btn], [data-buy-now]')) return;
      btn.setAttribute('aria-busy', 'true');
      var pending = btn.getAttribute('data-pending-label');
      if (pending) label(btn, pending);
      /* another handler may still cancel the submit — don't strand the button */
      setTimeout(function () { if (ev.defaultPrevented) idle(btn); }, 0);
    });

    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[aria-busy="true"]').forEach(idle);
    });
  })();
})();
